<template>
  <div class="topPanel">
    <div class="currentPlan">
      <div class="selectionName">{{ currentPlanName }}</div>
    </div>
    <div v-if="selectedMember && showMember" class="selectedMembers">
      <div v-if="warningMemberNotes">
          <v-btn icon color="error" @click="dialog = true">
            <v-icon> mdi-flag-variant</v-icon>
          </v-btn>
        </div>
      <div class="selectedMembersContainer">
        <div class="selectionName">
          {{
            `${selectedMember.Title} ${selectedMember.Forename} ${selectedMember.Surname} - ${selectedMember.StateNo} (${selectedMember.MembershipId})`
          }}
        </div>
      </div>
      <div v-if="selectedMembers.length > 1" class="memberNavArrows">
        <v-btn class="mx-2" fab dark x-small color="primary" @click="movePrev" :disabled="this.currentIndex <= 0">
          <v-icon dark> mdi-arrow-left </v-icon>
        </v-btn>
        <v-btn class="mx-2" fab dark x-small color="primary" @click="moveNext" :disabled="currentIndex >= this.selectedMembers.length - 1">
          <v-icon dark> mdi-arrow-right </v-icon>
        </v-btn>
      </div>
    </div>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class=""> Note </v-card-title>
        <v-card-text>
          {{ warningMemberNotes && warningMemberNotes.Notes }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false"> Close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'TopPanel',

  data: () => ({
    planList: [],
    memberNotes: [],
    dialog: false,
    selectedMember: null,
  }),

  computed: {
    currentPlanId() {
      return this.$store.getters.currentPlanId;
    },
    currentPlanName() {
      let planName = '';
      if (this.currentPlanId && this.planList && this.planList.length > 0) {
        const plan = this.planList.find((x) => {
          return x.Id == this.currentPlanId;
        });
        if (plan) planName = plan.ShortName;
      }
      return planName;
    },
    selectedMembers() {
      const selectedMember = this.$store.getters.selectedMember;
      if (selectedMember) {
        const taggedMembers = this.$store.getters.taggedMembers;
        return taggedMembers;
      } else {
        return [];
      }
    },

    warningMemberNotes() {
      if (this.memberNotes && this.memberNotes.length > 0) {
        const warningNotes = this.memberNotes.find((x) => x.NoteType == 'W');
        return warningNotes;
      }

      return null;
    },
    updateSelectedMemberNotes() {
      return this.$store.getters.updateSelectedMemberNotes;
    },
    showMember() {
      const menu = this.$store.getters.menu;

      if (menu && this.$route) {
        let rootMenuItem = menu.find((x) => {
          const selected = x.items.find((x) => {
            if (x.items.length) {
              return x.items.find((y) => y.to == this.$route.path);
            }
            return x.to == this.$route.path;
          });
          if (selected) {
            return true;
          }
          return false;
        });

        if (rootMenuItem) {
          if (rootMenuItem.title == 'Members') {
            return true;
          } else {
            return false;
          }
        }
      }

      return false;
    },

    currentIndex(){
      return this.$store.getters.getTaggedIndex;
    },
  },
  watch: {
    selectedMember() {
      this.getMemberNotes();
    },
    updateSelectedMemberNotes() {
      this.getMemberNotes();
    },
  },

  mounted: function () {
    this.getSchemeList();
    this.selectedMember = this.$store.getters.selectedMember;
    if (this.selectedMember && this.showMember) this.getMemberNotes();
  },

  methods: {
    async moveNext(event) {
      var index = this.$store.getters.getTaggedIndex;
      if (index >= 0 && index < this.selectedMembers.length - 1) {
        index++;
        this.$store.commit('setTaggedIndex', index);
        var memno = this.$store.getters.getTaggedMember;
        await this.selectMember(memno);
      }
      event.currentTarget.blur();
    },
    async movePrev(event) {
      var index = this.$store.getters.getTaggedIndex;
      if (index > 0) {
        index--;
        this.$store.commit('setTaggedIndex', index);
        var memno = this.$store.getters.getTaggedMember;
        await this.selectMember(memno);
      }
      event.currentTarget.blur();
    },

    onShowNote() {},
    async getSchemeList() {
      try {
        let response = await this.$api.get('/plans/getplanlist');

        if (!response.data.length) {
          const msg = 'Unable to load plans';
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }

        this.planList = response.data;
      } catch (err) {
        console.log(err);
      }
    },
    async getMemberNotes() {
      try {
        let response = await this.$api.get(
          '/Notes/GetMemberNotes?membershipId=' + this.selectedMember.MembershipId
        );
        this.memberNotes = response.data;
      } catch (err) {
        this.$store.commit('setNotificationMessage', {
          type: 'error',
          text: err.message,
        });
        console.error(err);
      } 
    },
    async selectMember(value) {
      if (value > 0) {
        this.$store.commit('setSelectedMemberId', value);
        this.getMemberData(value);
      }
    },
    async getMemberData(memberId) {
      if (memberId) {
        try {
          let response = await this.$api.get('/member/getmember?id=' + memberId);

          if (!response.data) {
            const msg = 'Unable to get member data';
            this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
            throw new Error(msg);
          }
          this.selectedMember = response.data;
        } catch (err) {
          console.error(err);
        } 
      }
    },
    isMemberSelected(member) {
      return member.MembershipId == this.$store.getters.selectedMemberId;
    },
  },
};
</script>

<style lang="scss" scoped>
.topPanel {
  width: 100%;
  margin-right: 20px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  background-color: white;
  font-family: Roboto;
  padding: 15px;

  .panelTitle {
    color: #565656;
    font-weight: normal;
    text-transform: uppercase;
  }

  .currentPlan {
    max-width: 350px;
  }

  .selectionName {
    background-color: #cbe9ff;
    padding: 8px;
    color: #1571cb;
    min-width: 40em;
  }

  .selectedMembers {
    //max-width: 580px;
    display: flex;
  }

  .memberNavArrows{
    display: flex;
    align-items: center;
  }
}
</style>
